import axios from "axios";

const runtimeApiOrigin =
  typeof window !== "undefined" && window.location.hostname.endsWith("nexoracd.cloud")
    ? "https://api.nexoracd.cloud"
    : typeof window !== "undefined"
      ? window.location.origin
      : "";
export const API_ORIGIN = (process.env.REACT_APP_BACKEND_URL || runtimeApiOrigin).replace(/\/$/, "");
export const API_BASE = `${API_ORIGIN}/api`;

export function apiUrl(path = "") {
  const cleanPath = String(path || "");
  if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) return cleanPath;
  return `${API_BASE}${cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`}`;
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error?.response?.status;
    const url = original?.url || "";
    if (
      status === 401 &&
      original &&
      !original._retry &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/logout") &&
      !url.includes("/auth/refresh")
    ) {
      original._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  if (!err?.response && err?.request) {
    return "Connexion API impossible. Verifiez internet puis reessayez.";
  }
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Erreur inconnue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail === "object") {
    const parts = [];
    if (detail.message) parts.push(detail.message);
    if (Array.isArray(detail.missing_details) && detail.missing_details.length) {
      parts.push(`Details manquants: ${detail.missing_details.join(", ")}`);
    }
    if (Array.isArray(detail.missing_documents) && detail.missing_documents.length) {
      parts.push(`Documents manquants: ${detail.missing_documents.join(", ")}`);
    }
    return parts.length ? parts.join(" | ") : JSON.stringify(detail);
  }
  return String(detail);
}

export const DRC_CENTER = { lat: -2.8799, lng: 23.656 };
export const DRC_MAP_ZOOM = 5;
export const CITY_MAP_ZOOM = 13;
export const BUNIA_CENTER = { lat: 1.5667, lng: 30.25 };

export function formatCDF(amount) {
  if (amount === undefined || amount === null) return "0 CDF";
  return `${Math.round(amount).toLocaleString("fr-FR")} CDF`;
}
